import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Loads all branch types once. Used by Branch and Package forms to pick a type,
 * and by Packages/Sales/Vehicle screens to label types by name.
 */
export default function useBranchTypes({ activeOnly = false } = {}) {
  const [types, setTypes] = useState([]);
  const [loading, setLoading] = useState(true);

  const reload = useCallback(async () => {
    setLoading(true);
    try {
      const { data } = await api.get("/branch-types", {
        params: activeOnly ? { active_only: true } : {},
      });
      setTypes(data || []);
    } finally {
      setLoading(false);
    }
  }, [activeOnly]);

  useEffect(() => {
    reload();
  }, [reload]);

  const byId = types.reduce((acc, t) => {
    acc[t.id] = t;
    return acc;
  }, {});

  return { types, byId, loading, reload };
}
